import { createApi } from '@stilingue/st-auth-utils';
import { isProdVersion } from '@stilingue/st-environment-controller-utils';
import { featureFlagFlags } from '@/plugins/rollout.js';
import { insightsHandler } from '@/utils';
import Service from '../Service.js';
import gateway from '../Gateway.js';

const version = isProdVersion()
  ? featureFlagFlags.InsightsServiceVersionProd.getValue()
  : featureFlagFlags.InsightsServiceVersionStaging.getValue();

const afterParser = (response) => response.data;

class InsightsService extends Service {
  constructor(gateway, version) {
    const api = createApi(`benchmarks-charts-service/${version}/`, gateway);

    super(api, {
      afterParser,
      retriesLimit: 3,
    });

    this.api.http.defaults.timeout = 300000;
  }

  getFanbaseEvolutionInsights(params = {}) {
    return this.find({
      params,
      url: 'followers/group-evolution-insights',
    }).then(insightsHandler);
  }

  getInteractionsOverTimeInsights(params = {}) {
    return this.find({
      params,
      url: 'interactions/group-insights',
    }).then(insightsHandler);
  }
}

export default new InsightsService(gateway, version);
